// extracted by mini-css-extract-plugin
export default {"tabsContainer":"Tabs_tabsContainer__UPxcN","tabItem":"Tabs_tabItem__kZGWi","tabItemActive":"Tabs_tabItemActive__NiDC6"};